/**
 * Cutluxe Accessibility Utilities
 *
 * Shared helper functions used by the custom accessibility scripts.
 * This file must be loaded before the other as-a11y-*.js files.
 */

(function () {
  window.ASA11y = window.ASA11y || {};

  /**
   * Checks whether an element is currently visible and available
   * to users on the page.
   */
  window.ASA11y.isVisible = function (element) {
    if (!element) return false;

    const style = window.getComputedStyle(element);

    return (
      !element.hidden &&
      element.getClientRects().length > 0 &&
      style.display !== "none" &&
      style.visibility !== "hidden" &&
      element.getAttribute("aria-hidden") !== "true" &&
      !element.closest("[hidden]") &&
      !element.closest("[inert]")
    );
  };

  /**
   * Runs the supplied callback after the initial DOM is available.
   */
  window.ASA11y.onReady = function (callback) {
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", callback, {
        once: true,
      });
    } else {
      callback();
    }
  };
})();
